import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import FromToFilter from 'ati-ui-react/widgets/Filter/FromToFilter';
import setUrlParam from 'utils/setUrlParam';
import inputRestriction from 'utils/inputRestriction';

import SearchParameter from '../SearchParameter';

const RentPrice: FC = observer(() => {
  const {
    findTrucksStore: {
      fields: { price },
      updateFromTo,
    },
  } = useStores();

  return (
    <SearchParameter captionNode="Стоимость, руб." double volumeAndWeight rentPrice>
      <FromToFilter
        fromValue={price?.from}
        toValue={price?.to}
        onChange={(event: string, value: string) => {
          updateFromTo({ event, value: Number(value), field: 'price' });
          setUrlParam({ field: `price_${event}`, value });
        }}
        maxLength={9}
        viceVersa
        inputRestriction={inputRestriction.numbersOnly}
      />
    </SearchParameter>
  );
});

export default RentPrice;
